/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bland_Yummy_Gazelle_EnjoyInputs */

const fr_bland_yummy_gazelle_enjoy = /** @type {(inputs: Bland_Yummy_Gazelle_EnjoyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mot de passe doit contenir au moins 6 caractères`)
};

/**

* @param {Bland_Yummy_Gazelle_EnjoyInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bland_yummy_gazelle_enjoy = /** @type {((inputs?: Bland_Yummy_Gazelle_EnjoyInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bland_Yummy_Gazelle_EnjoyInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bland_yummy_gazelle_enjoy(inputs)
});